import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Switch } from '@chakra-ui/react';
import { OptionLabel } from '../OptionLabel/component.js';
var _excluded = ["children", "label", "helpText", "tooltip"];
var Toggle = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    label = _ref.label,
    helpText = _ref.helpText,
    tooltip = _ref.tooltip,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Switch, _extends({
    ref: ref
  }, rest), label && /*#__PURE__*/React.createElement(OptionLabel, {
    label: label,
    helpText: helpText,
    tooltip: tooltip
  }, children));
});
Toggle.displayName = 'toggle';
export { Toggle };